import { LabelText } from 'shared/ui/label';
import { Container } from './styles';
import { Controller } from 'react-hook-form';
import { TagsOptions } from 'entities/tags';
import { unmaskPhone } from 'shared/lib/string';
import { Input, InputText } from 'shared/ui/Inputs/Input';
import { Textarea } from 'shared/ui/Inputs/textarea';
import { OrderPersonInfoCard, OrderPersonInfoContent } from 'entities/orders';
import { Typography } from 'shared/ui/typography';
import { PenIconButton } from 'shared/ui/buttons/iconButtons/penButton';
import { useBookingClientForm } from '../lib/hooks/useBookingClientForm';
import { useModal } from 'shared/lib/modal';
import { Person, resetPersonDetail, setSelectedPerson, usePerson } from 'entities/person';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { selectSettingDefaultPerson } from 'entities/settings';
import { PersonButton } from 'shared/ui/buttons/iconButtons/personButton';
import { PaginationHook, usePaginationFilterPersons } from 'shared/lib/pagination';
import { useClientForm } from '../lib/hooks/useClientForm';
import { selectBookingIsNew } from 'entities/orders/model/selectors';
import { CloseIconButton } from 'shared/ui/buttons/iconButtons/closeButton';

export const BookingClientForm = () => {
	const {
		registerWithMask,
		searchAfterPaste,
		getPersonsByPhone,
		changeName,
		changeNotes,
		selectTags,
    resetClientData,
		phoneMask,
		person,
		errors,
		control,
	} = useBookingClientForm();

  const { setOpenPersonBook, setSearchMode } = usePerson();
  const { fetchDataWithDispatch } = usePaginationFilterPersons() as PaginationHook;

	const { openModal } = useModal();
	const { activeBookingBtn } = useClientForm();
	const defaultPersonId = useAppSelector(selectSettingDefaultPerson);
	const isNew = useAppSelector(selectBookingIsNew);

	const reset = () => {
		resetClientData();
		resetPersonDetail();
		activeBookingBtn();
	};

	const dispatch = useAppDispatch();
	const openPersonModal = async () => {
		await dispatch(setSelectedPerson(person as Person));
		openModal();
	};

  const onPersonClick = () => {
    setOpenPersonBook(true);
    setSearchMode('searchByName');
    fetchDataWithDispatch({ search: '', page: 1 });
  }

	return (
		<OrderPersonInfoCard
			title={!person ? 'Новый гость' : 'Контактная информация'}
			buttons={[
				<PenIconButton
					onClick={openPersonModal}
					hide={!person || person.id === defaultPersonId}
          key={0}
				/>,
        <PersonButton 
          onClick={onPersonClick}
          hide={!person}
          key={1} 
        />,
				<CloseIconButton
					onClick={reset}
					styles={{
						iconHeight: '15px',
						width: '25px',
						height: '25px',
					}}
					hide={!person||!isNew}
          key={2}
				/>,
			]}
		>
			{person?.id ? (
				<OrderPersonInfoContent person={person} />
			) : (
				<form>
					<Container>
						<LabelText>Телефон</LabelText>
						<InputText
							{...registerWithMask('phone', [phoneMask.current], {
								onBeforeMask: (initialValue) => {
									if (initialValue.startsWith('89')) {
										return initialValue.replace('8', '');
									}

									if (initialValue.startsWith('7')) {
										return initialValue.replace('7', '');
									}

									return initialValue;
								},
								validate: value => {
									if (!value || person) {
										return true;
									}
									if (unmaskPhone(value).length !== 12) {
										return 'Некорректный номер телефона';
									}
								},
								onBeforePaste: (pastedValue) => {

									if (pastedValue.startsWith('8')) {
										searchAfterPaste(`+${pastedValue.replace('8', '7')}`);
										return `+${pastedValue.replace('8', '7')}`;
									}

									if (!pastedValue.startsWith('+')) {
										searchAfterPaste(`+${pastedValue}`);

										return `+${pastedValue}`;
									}

									searchAfterPaste(pastedValue);

									return pastedValue;
								},
							})}
							onChange={getPersonsByPhone}
							autoComplete="off"
							$textIndent="15px"
						/>
						{errors.phone && (
							<Typography colorVariant={'danger'} mode="small">
								{errors.phone.message}
							</Typography>
						)}
					</Container>
					<Container>
						<LabelText>Имя и фамилия</LabelText>
						<Controller
							name="name"
							control={control}
							rules={{ required: 'Имя обязательно' }}
							render={({ field }) => (
								<>
									<Input
										name={field.name}
										value={field.value}
										onChange={event =>
											changeName(event, field)
										}
									/>
									{errors.name && (
										<Typography
											colorVariant={'danger'}
											mode="small"
										>
											{errors.name.message}
										</Typography>
									)}
								</>
							)}
						/>
					</Container>
					<Container>
						<LabelText>Важная информация</LabelText>
						<Controller
							name="notes"
							control={control}
							render={({ field }) => (
								<Textarea
									name={field.name}
									value={field.value}
									onChange={event =>
										changeNotes(event, field)
									}
								/>
							)}
						/>
					</Container>
					<Container>
						<LabelText>Теги</LabelText>
						<TagsOptions isForOrder={false} onSelect={selectTags} tagsOptions={person?.tags} />
					</Container>
				</form>
			)}
		</OrderPersonInfoCard>
	);
};
